import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppStorageService } from '../../services/app-storage.service';
import { StorageKeys } from '../../services/storage-keys';

export const NoAuthGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const storage = inject(AppStorageService);

  if (storage.get(StorageKeys.GUEST) === 'false') {
    router.navigateByUrl('/app/home');
    return false;
  }

  return true;
};
